<template>
  <div>
    <div class="text-center">
      Access the projects of your attached seeker accounts
    </div>

    <div v-if="allLocalProjects.length !== 0">
      <div class="hpanel ">
        <div class="panel-heading">
          <h3 class="text-center font-bold">Projects <span>({{allLocalProjects.length}})</span></h3>
        </div>
      </div>

      <div class="row projects" style="margin-bottom: 30px">
        <template v-for="(project, key) in allLocalProjects">
          <template v-if="key % 2 === 0">
            <div class="row"></div>
          </template>
          <project-item :key="key" class="col-md-6 col-sm-12" :project="project" v-model="refresh"/>
        </template>
      </div>
    </div>
  </div>
</template>

<style>
  #dLabel1, #dLabel2{color: #fff;
    background-color: #204d74;
    border-color: #122b40}
  .m-t-md {
    margin-top: 22px;
  }
</style>

<script>
import PortfolioListRow from '../../components/project/PortfolioListRow'
import ProjectItem from '../../components/project/ProjectItem'

export default {
  components: {
    ProjectItem,
    PortfolioListRow
  },
  props: ['projects'],
  name: 'ConsultantProjects',
  data () {
    return {
      refresh: null,
      allLocalProjects: []
    }
  },
  watch: {
    projects: function () {
      this.parse()
    },
    refresh: function (value) {
      this.$emit('input', value)
    }
  },
  methods: {
    parse: function () {
      this.allLocalProjects = this.projects.filter((project) => {
        return project.owner_id !== null && project.owner_id !== this.$auth.user().id &&
          ((project.question !== null && project.question.consultant !== null &&
            project.question.consultant.id === this.$auth.user().id) ||
            (project.owner_id !== this.$auth.user().id && project.owner.intermediary_id === this.$auth.user().id))
      })

      this.allLocalProjects.sort((project1, project2) => {
        return new Date(project2.updated_at) - new Date(project1.updated_at)
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/ConsultantProjects.vue